import React from "react";
import { Card, CardContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SidebarPrompt = ({ icon, message, onClose, onClick }) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        display: "flex",
        bgcolor: (theme) => theme.palette.background.main,
        alignItems: "center",
        cursor: "pointer",
        position: "relative",
        p: 1.5,
        borderRadius: 2,
        border: "none",
        mx: 1.5,
        mt: 1,
      }}
    >
      <CardContent sx={{ p: 0, mr: 2.5, flexGrow: 1 }}>
        <Typography variant="body2">
          {" "}
          <span
            style={{
              verticalAlign: "text-bottom",
              display: "inline-flex",
              alignItems: "center",
              marginRight: 6,
              fontSize: "1rem",
            }}
          >
            {React.cloneElement(icon, {
              fontSize: "inherit",
              color: "inherit",
            })}
          </span>
          {message}
        </Typography>
      </CardContent>

      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation(); // prevent onClick from firing
          onClose();
        }}
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Card>
  );
};

export default SidebarPrompt;
